// FilterHeader.tsx – Component header tùy chỉnh
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { IHeaderParams } from 'ag-grid-community';
import { DatePicker } from 'antd';
import { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getFilterListPhoneCustomer, IPhoneFilterListPhoneCustomer } from '../../api/customer/customerApi';
import { getListCustomerTypes, getListDistrict, getlistDistrictCustomer, getlistProvinceCustomer, getListRankCustomer, getListServiceInvoiceBranch, getlistUnitCustomer, ICustomerTypes } from '../../api/selectOption/selectOptionsApi';
import { getListCodeCustomer, getListProvince, getListProvinceChild, ICodeCustomer, IProvince, IprovinceChild, ITag } from '../../api/selectOptions/selectOptionsApi';
import useDebounce from '../../hook/useDebounce';
import useThrottle from '../../hook/useThrottle';
import { dataGender, dataTypeCustomer } from '../../services/data';
import { selectorInfoUser } from '../../store/slices/infoUserSlice';
import { fommatdataCodeCustomer, fommatdataDefault, fommatdataRank, fommatdataType } from '../../until';
import { IDataDefaulFilterList } from './indexV2';
import { FilterIcon } from './Modal/FilterIcon';
import ModalFilter from './Modal/ModalFilter';
import ModalFilterDatePicker from './Modal/ModalFilterDatePicker';
import { ModalFilterTypeCustomer } from './Modal/ModalFilterTypeCustomer';
import { ModalProvince } from './Modal/ModalProvince';
import './styles.scss';
import useLoading from '../../hook/useLoading';
import { selectorCategoryCarIds } from '../../store/slices/categoryCarSlice';
const { RangePicker } = DatePicker;
interface FilterHeaderProps extends IHeaderParams {
  dataFilterList: IDataDefaulFilterList
  fieldLabel?: string;
  // setListPhone: (e: string[]) => void;

  setDataFilterList: (dataFilterList: IDataDefaulFilterList) => void,
}

const FilterHeader: React.FC<FilterHeaderProps> = (props) => {
  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const pushLoading = useLoading()

  const {
    displayName, column, api, dataFilterList,
    setDataFilterList,
  } = props;

  const prevSearchRef = useRef<string | undefined>(undefined);
  const scrollRef = useRef<Record<string, HTMLDivElement | null>>({});


  const columnId = column.getColId()
  const hiddenFilterIcon = new Set(
    ['cus_name', 'cus_channels_name', 'cus_dms_id_card_no', 'cus_email', 'cus_address', 'adminName',
      'cus_marital_status', 'cus_career_name', 'cus_tax_reg_no_dms', 'cus_interest', 'cus_route_name',
      'cus_business_field', 'cus_group_name', 'cus_note', 'cus_scope',
      'cus_recent_care_staff', "total_purchase_invoices", "total_service_invoices", "total_vehicle_passenger",
      "total_vehicle_bus", "total_service_amount", "total_purchase_amount", "total_amount",
      "total_use_vehicles", "total_owner_vehicles", "cus_recent_care_staff", "cus_note", "cus_founding_date", "age_customer"

    ]);
  const isHiddenFilterIcon = hiddenFilterIcon.has(columnId)

  const [activeSort, setActiveSort] = useState<null | 'asc' | 'desc'>(null);

  const [openModal, setOpenModal] = useState(false)
  const [openModalTypeCustomer, setOpenModalTypeCustomer] = useState(false)
  const [openModalProvinceChild, setOpenModalProvinceChild] = useState(false)
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [checkShowSearch, setCheckShowSearch] = useState(false);

  const [checkedValues, setCheckedValues] = useState<(string | number)[]>([]);

  const [sLCustomerType, setSLCustomerType] = useState<ICustomerTypes[]>([])
  const [sLProvince, setSLProvince] = useState<IProvince[]>([])
  const [sLDistrict, setSLDistrict] = useState<ITag[]>([])
  const [sLCodeCustomer, setSLCodeCustomer] = useState<ICodeCustomer[]>([])
  const [sLProviChild, setSLProviChild] = useState<IprovinceChild[]>([])
  const [sLUnit, setSLUnit] = useState<ITag[]>([])
  const [sLPhoneV2, setSLPhoneV2] = useState<any[]>([])
  const [dataRank, setDataRank] = useState<any[]>([])


  const [search, setSearch] = useState<string>()


  const [paginationFilterHeader, setPaginationFilterHeader] = useState({
    cusTel: { current: 1, pageSize: 30, total: 0 },
    rank: { current: 1, pageSize: 30, total: 0 },
    cusCode: { current: 1, pageSize: 30, total: 0 }
  });





  const toNumberArray = (arr: (string | number)[]) => {
    return arr.map(Number).filter(Number.isFinite) as number[]
  }

  const toStringArray = (arr: (string | number)[]) => arr.map(String);

  const gSLFilterData = () => {
    if (openModal) {
      switch (columnId) {
        case 'cus_code':
          return fommatdataCodeCustomer(sLCodeCustomer);
        case 'cus_gender_name':
          return fommatdataDefault(dataGender);
        case 'cus_type_name':
          return fommatdataType(dataTypeCustomer);
        case 'cus_city':
          return fommatSLDistrict(sLProvince);
        case 'cus_ward':
          return fommatSLDistrict(sLDistrict);
        case 'cus_branch_name':
          return sLUnit;
        case 'cus_tel':
          return sLPhoneV2;
        case 'rank':
          return fommatdataRank(dataRank);
        default:
          return [];
      }

    } else {
      return []
    }
  }

  const gSLFilterListPhoneCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await getFilterListPhoneCustomer(
      permittedCategoryCarIds,
      30, current, search, unitTemp
    );
    if (result?.status) {
      // Append nếu current > 1
      setSLPhoneV2(prev =>
        current === 1 ?
          fommatdataPhoneFilter(result.data) :
          [...prev, ...fommatdataPhoneFilter(result.data)]
      );


      setPaginationFilterHeader({
        ...paginationFilterHeader,
        cusTel: { ...paginationFilterHeader.cusTel, current: current, total: result.total || 0 }
      })
    }
    pushLoading(false)
  }, 300)

  const getListUnit = async () => {
    pushLoading(true)

    const result = await getlistUnitCustomer(
      search, unitTemp
    )
    if (result?.status) {

      const units = result.data.map(item => ({
        id: item.id,
        title: item.title,
      }));

      setSLUnit(units)
    }


    pushLoading(false)
  }

  const gSLFilterListRankCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await getListRankCustomer(
      30, current, search, unitTemp
    );
    if (result?.status) {
      // Append nếu current > 1

      setDataRank(prev =>
        current === 1 ?
          result.data :
          [...prev, ...result.data]
      );


      setPaginationFilterHeader({
        ...paginationFilterHeader,
        rank: { ...paginationFilterHeader.rank, current: current, total: result.total || 0 }
      })
    }
    pushLoading(false)
  }, 300)


  const gSListProvinceChild = async () => {
    pushLoading(true)
    const result = await getListProvinceChild(search);
    if (result?.status) {
      setSLProviChild(result.data)
    }
    pushLoading(false)
  }

  const gSListCodeCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await getListCodeCustomer(
      permittedCategoryCarIds,
      undefined, search, unitTemp, undefined,
      30, current
    );
    if (result?.status) {

      setSLCodeCustomer(prev =>
        current === 1 ?
          result.data :
          [...prev, ...result.data]
      );

      setPaginationFilterHeader({
        ...paginationFilterHeader,
        cusCode: { ...paginationFilterHeader.cusCode, current: current, total: result.total || 0 }
      })
    }
    pushLoading(false)
  }, 300)

  const gSLCustomerTypes = async () => {
    pushLoading(true)
    const result = await getListCustomerTypes(search);
    if (result?.status)
      setSLCustomerType(result.data)
    pushLoading(false)
  }

  const gSLProvince = async () => {
    pushLoading(true)
    const result = await getListProvince(
      search
    );
    if (result?.status) {
      setSLProvince(result.data)
    }
    pushLoading(false)
  }

  const gSLDistrict = async () => {
    pushLoading(true)
    const result = await getListDistrict(search);
    if (result?.status) {
      setSLDistrict(result.data)
    }
    pushLoading(false)
  }

  const isColumnFiltered = useMemo(() => {
    switch (columnId) {
      case 'cus_type_name': return !!dataFilterList.businessCheck?.length;
      case 'cus_branch_name': return !!dataFilterList.listUnit?.length;
      case 'cus_gender_name': return !!dataFilterList.gender?.length;
      case 'cus_ward': return !!dataFilterList.listWard?.length;
      case 'cus_code': return !!dataFilterList.listCode?.length;
      case 'cus_tel': return !!dataFilterList.listPhone?.length;
      case 'rank': return !!dataFilterList.listRank?.length;
      case 'cus_lifecycle_status': return !!dataFilterList.listType?.length;
      case 'cus_birth_day': return !!(dataFilterList.dateStart);
      case 'cus_city': return !!dataFilterList.listProvince?.length;
      default: return false;
    }
  }, [columnId, dataFilterList]);


  const fommatSLDistrict = (arr: ITag[]) => {
    // const newData = arr?.map(item => ({
    //   id: item.id,
    //   title: item.title
    // }));
    // return newData

    const newData = arr.map((item) => ({
      id: item.id,
      title: item.title,
    }));

    return [
      {
        id: -2,
        title: "Không xác định",
      },
      ...newData,
    ];
  }

  // const fommatdataPhoneFilter = (arr: IPhoneFilterListPhoneCustomer[]) => {
  //   const unique = [...new Set(arr.map(item => item.phone))].map(phone => ({ id: phone, title: phone }));
  //   return [...unique, { id: '0', title: NO_DATA }];
  // }

  //Tạm ẩn cả a tui viết chưa xong
  const fommatdataPhoneFilter = (arr: IPhoneFilterListPhoneCustomer[]) => {
    const unique = [...new Set(arr.map(item => item.phone))].map(phone => ({ id: phone, title: phone }));
    return [...unique];
  }

  const handleSortRequest = (order: 'asc' | 'desc' | null) => {
    let newSort: null | 'asc' | 'desc' = null;
    switch (order) {
      case 'asc':
        newSort = 'desc'
        break;
      case 'desc':
        newSort = null
        break;
      default:
        newSort = 'asc'
        break;
    }
    setActiveSort(newSort);
    api.applyColumnState({
      state: [
        {
          colId: columnId,
          sort: newSort || undefined,
        }
      ],
      defaultState: { sort: null },
    });
  };



  const handleFilterClick = useThrottle(() => {

    switch (columnId) {
      case 'cus_lifecycle_status':
        setCheckedValues(dataFilterList.listType)
        setOpenModalTypeCustomer(true);
        setCheckShowSearch(true);
        break;
      case 'cus_birth_day':
        setIsDatePickerOpen(true);
        break;
      case 'cus_gender_name':
        setCheckedValues(dataFilterList.gender)
        setOpenModal(true)
        break;
      case 'cus_type_name':
        setCheckedValues(dataFilterList.businessCheck)
        setOpenModal(true)
        break;
      case 'cus_branch_name':
        setCheckedValues(dataFilterList.listUnit)
        setCheckShowSearch(true);
        setOpenModal(true)
        break;
      case 'cus_city':
        setCheckedValues(dataFilterList.listProvince)
        setCheckShowSearch(true);
        setOpenModal(true)
        break;
      case 'cus_ward':
        setCheckedValues(dataFilterList.listWard)
        setCheckShowSearch(true);
        setOpenModal(true)
        break;
      case 'cus_code':
        setCheckedValues(dataFilterList.listCode)
        setCheckShowSearch(true);
        setOpenModal(true)
        break;
      case 'cus_tel':
        setCheckedValues(dataFilterList.listPhone)
        setCheckShowSearch(true);
        setOpenModal(true)
        break;
      case 'rank':
        setCheckedValues(dataFilterList.listRank)
        setCheckShowSearch(true);
        setOpenModal(true)
        break;
      default: setOpenModal(true);
        break;
    }
  }, 1000)

  const handleSearch = useDebounce((value?: string) => {
    setSearch(value);

  }, 500);

  const handleFilterColumnSelectChange = (columnCode: string, value: (string | number)[]) => {

    switch (columnCode) {
      case 'cus_type_name':
        setDataFilterList({ ...dataFilterList, businessCheck: toNumberArray(value) })
        break;
      case 'cus_branch_name':
        setDataFilterList({ ...dataFilterList, listUnit: toNumberArray(value) })
        break;
      case 'cus_gender_name':
        setDataFilterList({ ...dataFilterList, gender: toNumberArray(value) })
        break;
      case 'cus_city':
        setDataFilterList({ ...dataFilterList, listProvince: toNumberArray(value) })
        break;
      case 'cus_ward':
        setDataFilterList({ ...dataFilterList, listWard: toNumberArray(value) })
        break;
      case 'cus_code':
        setDataFilterList({ ...dataFilterList, listCode: toStringArray(value) })
        break;
      case 'cus_tel':
        setDataFilterList({ ...dataFilterList, listPhone: toStringArray(value) })
        break;
      case 'rank':
        setDataFilterList({ ...dataFilterList, listRank: toNumberArray(value) })
        break;
      case 'cus_lifecycle_status':
        setDataFilterList({ ...dataFilterList, listType: toNumberArray(value) })
        break;
      default:
        break;
    }
  }

  const handleFilterColumnDate = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (dates && dates[0] && dates[1]) {
      setDataFilterList({ ...dataFilterList, dateStart: dates[0].format('YYYY/MM/DD'), dateEnd: dates[1].format('YYYY/MM/DD') })
    }
    else {
      setDataFilterList({ ...dataFilterList, dateStart: '', dateEnd: '' })
    }
  };

  const onPopupScroll = (e: any, columnId: string) => {
    const target = e.target;
    const isBottom =
      (target.scrollTop + target.offsetHeight) >= target.scrollHeight - 100;


    switch (columnId) {
      case "cus_tel": {
        const { current, total } = paginationFilterHeader.cusTel;
        const hasMore = sLPhoneV2.length < total;

        if ((current + 1) * 30 >= total) {
          return
        }
        if (isBottom && hasMore) {
          pushLoading(true)
          const nextPage = current + 1;
          gSLFilterListPhoneCustomer(nextPage);
        }
        pushLoading(false)
        break;
      }

      case "rank": {
        const { current, total } = paginationFilterHeader.rank;
        const hasMore = dataRank.length < total;

        if ((current + 1) * 30 >= total) {
          return
        }
        if (isBottom && hasMore) {
          pushLoading(true)
          const nextPage = current + 1;
          gSLFilterListRankCustomer(nextPage);
        }
        pushLoading(false)
        break;
      }
      case "cus_code": {
        const { current, total } = paginationFilterHeader.cusCode;
        const hasMore = sLCodeCustomer.length < total;

        if ((current + 1) * 30 >= total) {
          return
        }
        if (isBottom && hasMore) {
          pushLoading(true)
          const nextPage = current + 1;
          gSListCodeCustomer(nextPage);
        }
        pushLoading(false)
        break;
      }

      default:
        break;
    }
  };

  useEffect(() => {
    if (openModal) {
      switch (columnId) {
        case 'cus_city':
          if (!sLProvince.length) {
            gSLProvince();
          }
          if (search !== prevSearchRef.current) {
            gSLProvince();
          }
          // cập nhật prevSearchRef sau khi chạy
          prevSearchRef.current = search;
          break;
        case 'cus_ward':
          if (!sLDistrict.length) {
            gSLDistrict();
          }
          if (search !== prevSearchRef.current) {
            gSLDistrict();
          }
          // cập nhật prevSearchRef sau khi chạy
          prevSearchRef.current = search;
          break;


        case 'cus_branch_name':
          if (!sLUnit.length) {
            getListUnit();
          }
          if (search !== prevSearchRef.current) {
            getListUnit();
          }
          // cập nhật prevSearchRef sau khi chạy
          prevSearchRef.current = search;
          break;

        case 'cus_code': {
          if (!sLCodeCustomer.length && !search) {
            gSListCodeCustomer();
            return
          }

          if (search !== prevSearchRef.current) {
            gSListCodeCustomer();
            // cập nhật prevSearchRef sau khi chạy
            prevSearchRef.current = search;

            if (scrollRef.current["cus_code"]) {
              scrollRef.current["cus_code"]?.scrollTo({ top: 0 });
            }
          }
          break;
        }

        case 'cus_tel': {
          if (!sLPhoneV2.length && !search) {
            gSLFilterListPhoneCustomer();
            return
          }

          if (search !== prevSearchRef.current) {
            gSLFilterListPhoneCustomer();
            // cập nhật prevSearchRef sau khi chạy
            prevSearchRef.current = search;

            if (scrollRef.current["cus_tel"]) {
              scrollRef.current["cus_tel"]?.scrollTo({ top: 0 });
            }
          }
          break;
        }
        case 'rank': {
          if (!dataRank.length && !search) {
            gSLFilterListRankCustomer();
            return
          }

          if (search !== prevSearchRef.current) {
            gSLFilterListRankCustomer();
            // cập nhật prevSearchRef sau khi chạy
            prevSearchRef.current = search;

            if (scrollRef.current["rank"]) {
              scrollRef.current["rank"]?.scrollTo({ top: 0 });
            }
          }
          break;
        }
        default:
          break;
      }


    }
  }, [openModal, search])

  useEffect(() => {
    if (!sLCustomerType.length) {
      if (openModalTypeCustomer && columnId === 'cus_lifecycle_status') {
        gSLCustomerTypes();
      }
    }
    if (search !== prevSearchRef.current) {
      gSLCustomerTypes();
    }
    // cập nhật prevSearchRef sau khi chạy
    prevSearchRef.current = search;
  }, [openModalTypeCustomer, search]);

  useEffect(() => {
    if (!sLProviChild.length) {
      if (openModalProvinceChild && columnId === 'district') {
        gSListProvinceChild();
      }
    }
    if (search !== prevSearchRef.current) {
      gSListProvinceChild();
    }
    // cập nhật prevSearchRef sau khi chạy
    prevSearchRef.current = search;
  }, [openModalProvinceChild, search]);

  return (
    <>
      <ModalFilter
        isOpen={openModal}
        scrollRef={scrollRef}
        columnCode={columnId}
        checkShowSearch={checkShowSearch}
        selectedValues={checkedValues}


        sLData={gSLFilterData()}
        handleSearch={handleSearch}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        closeModal={setOpenModal}

        onPopupScroll={onPopupScroll}
      />
      <ModalFilterTypeCustomer
        selectedValues={checkedValues}
        columnCode={columnId}
        isOpen={openModalTypeCustomer}
        dataFiler={sLCustomerType}
        handleSearch={handleSearch}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        closeModal={setOpenModalTypeCustomer}
      />
      <ModalProvince
        columnCode={columnId}
        selectedValues={checkedValues}
        isOpen={openModalProvinceChild}
        dataFiler={sLProviChild}
        handleFilterColumnSelectChange={handleFilterColumnSelectChange}
        handleSearch={handleSearch}
        closeModal={setOpenModalProvinceChild}
      />

      <ModalFilterDatePicker
        isOpen={isDatePickerOpen}
        rangeValue={[dataFilterList?.dateStart, dataFilterList?.dateEnd]}
        handleDateChange={handleFilterColumnDate}
        closeModal={setIsDatePickerOpen}
      />

      <div className='d-flex align-center gap-1'>
        <span>{displayName}</span>
        <div className='d-flex align-center gap-1'>
          <div className='d-flex flex-column'
            onClick={() => handleSortRequest(activeSort)}
          >
            <CaretUpOutlined
              hidden={activeSort === 'desc'}
              className={`cursor-pointer text-10-px `}
            />
            <CaretDownOutlined
              hidden={activeSort === 'asc'}
              className={`cursor-pointer text-10-px `}
            />
          </div>
          <div
            hidden={isHiddenFilterIcon}
            onClick={handleFilterClick}
            style={{ marginLeft: 0, cursor: 'pointer' }}
          >
            <FilterIcon isFiltered={isColumnFiltered} />
          </div>
        </div>

      </div>
    </>

  );
};

export default FilterHeader;
